<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :data="model" scrollable
                   :title="model.uuid ? $t(`Update Feature Request`) : $t(`Create New Feature Request`)" @show="onShow"
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="title"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="priority" type="select2" :items="priorities"
                        value-field="value" display-field="${item.key}"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="module_name" type="select2" :items="modulesNames"
                        value-field="value" display-field="${item.key}"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="description" type="ckeditor"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import FeatureRequestModel from "@/modules/feature-request/FeatureRequest.model";

  const {mapState, mapActions} = createNamespacedHelpers('featureRequest');

  export default {
    name: "FeatureRequestModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new FeatureRequestModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.modal,
        editObject: state => state.modal.object,
        priorities: state => state.priorities,
        modulesNames: state => state.modulesNames,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject) {
          this.model = new FeatureRequestModel(this.editObject);
        }
      },
    },
    methods: {
      ...mapActions(['hideModal', 'updateFeatureRequest', 'createFeatureRequest']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new FeatureRequestModel();
        this.hideModal();
      },
      async onSubmit() {
        await this.$refs.observer.reset();
        let validateSuccess = await this.$refs.observer.validate();
        if (!validateSuccess) {
          return;
        }

        let requestData = this.model.toJSON()
        let response;

        if (!this.model.uuid) {
          response = await this.createFeatureRequest(requestData);
        } else {
          response = await this.updateFeatureRequest(requestData);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Feature request was successfully created'));
          } else {
            this.$toast('success', this.$t('Feature request was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            if (response.body.non_field_errors) {
              this.$errorDialog(response.body.non_field_errors[0])
            } else {
              this.model.setMultipleErrors(response.body)
            }
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
